import { Tree } from 'element-ui';
/* eslint-disable func-names */
/**
 * element-ui el-tree 확장
 * @type {[type]}
 */
export default {
  name: Tree.name,
  extends: Tree,
  methods: {
    /**
     * 체크된 노드 중 필터링된 노드만 반환한다. (node.visible = true)
     * @author Ju
     * @param  {Boolean} [leafOnly=false]           [description]
     * @param  {Boolean} [includeHalfChecked=false] [description]
     * @return {[type]}                             [description]
     */
    getFilteredCheckedNodes(leafOnly = false, includeHalfChecked = false) {
      const checkedNodes = [];
      const traverse = function (node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;

        childNodes.forEach((child) => {
          if (((child.checked || (includeHalfChecked && child.indeterminate)) && (!leafOnly || (leafOnly && child.isLeaf))) && child.visible) {
            checkedNodes.push(child.data);
          }

          traverse(child);
        });
      };

      traverse(this);

      return checkedNodes;
    },
  },
};
/* eslint-enable func-names */



// WEBPACK FOOTER //
// ./src/extends/element-ui/tree/components/el-tree.js